import { queryAllPages } from '../../apollo/query-all-pages';
import { gql } from "@apollo/client";
import { client } from "../../apollo/client";

const USERS_REQUESTS = gql`
  query GetUsers {
    users(limit: 1000, offset: 0) {
      data {
        id
        dataCadastro
        customer
        name
        email
      }
      totalRecords
    }
  }
`;

const USER_REQUESTS = gql`
  query GetUser($userId: ID!) {
    user(userId: $userId) {
        id
        dataCadastro
        customer
        name
        email
    }
  } 
`;

export const getAllUsers = async () => {
  
    const response = await queryAllPages(client, {
      query: USERS_REQUESTS,
      // variables: {
      //   input: bar
      // }
    });
    const { data } = response.data.users;
    return data;
  
}

export const getUser = async (userId) => {
  
    const response = await queryAllPages(client, {
      query: USER_REQUESTS,
      variables: {
        userId: parseInt(userId)
      }
    });
    const { user } = response.data;
    return user;
  
}